import client from "./_client";

const endpointV1 = "/v1/free-access";

export const getFreeAccessUser = (deviceId) =>
  client.get(endpointV1 + `?deviceId=${deviceId}`);
